// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"687":"9d492eba","3824":"9d492eba","9553":"58297519"}[chunkId] + ".chunk.css";
};